const state = {
  title: null,
  subTitle: null,
};

const getters = {
  pageMeta: (state) => state,
};

const actions = {
  setPageTitle({ commit }, title) {
    document.title = `${this._vm.$userPrefs.getCurrentUi().title} | ${title}`;
    commit("setPageTitle", title);
  },

  /**
   * @param commit
   * @param {string[]} subTitle Array of subtitles, each set to separate p tag
   */
  setPageSubtitle({ commit }, subTitle) {
    commit("setPageSubtitle", subTitle);
  },
};

const mutations = {
  setPageTitle: (state, title) => (state.title = title),
  setPageSubtitle: (state, subTitle) => (state.subTitle = subTitle),
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
